export default {"src":"/_next/static/media/info-logo.9ae77133.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};